import Tab from "components/Tab";
import WebNetwork from "../../../../contents/docs/session-replay/_snippets/web-network.mdx";
import AndroidNetwork from "../../../../contents/docs/session-replay/_snippets/android-network.mdx";
import IOSNetwork from "../../../../contents/docs/session-replay/_snippets/ios-network.mdx";
import ReactNativeNetwork from "../../../../contents/docs/session-replay/_snippets/react-native-network.mdx";
import * as React from 'react';
export default {
  Tab,
  WebNetwork,
  AndroidNetwork,
  IOSNetwork,
  ReactNativeNetwork,
  React
};